import React from 'react';
import PropTypes from 'prop-types';

/**
 * Represents the Essilor Brazil specific map info content for map markers when clicked.
 */
const MapInfoContent = (props) => {
  const { children } = props;

  return (
    <div className="map-info-content">
      {children}
    </div>
  );
};

MapInfoContent.propTypes = {
  children: PropTypes.node.isRequired
};

export default MapInfoContent;
